import CryptoJS from "crypto-js";

const DEFAULT_KEY = "portal-login-aes-v1-change-in-prod";

export function getLoginPasswordAesKey() {
  return process.env.VUE_APP_LOGIN_PASSWORD_AES_KEY || DEFAULT_KEY;
}

function aesKeyWordArray() {
  const passphrase = getLoginPasswordAesKey();
  return CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(passphrase));
}

/**
 * 登录请求中的 password 字段：AES-256-CBC（随机 IV）再 Base64，
 * 与后端 LOGIN_PASSWORD_AES_KEY（SHA256 派生密钥）一致。
 */
export function encryptLoginPassword(plainPassword) {
  if (plainPassword == null || plainPassword === "") {
    return "";
  }
  const key = aesKeyWordArray();
  const iv = CryptoJS.lib.WordArray.random(128 / 8);
  const encrypted = CryptoJS.AES.encrypt(plainPassword, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const combined = iv.concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
}
